module.exports = __webpack_public_path__ + "img/Fingerprint-scanner.ed3cce47.svg";